var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choseCompany-main"},[_c('div',{staticClass:"main-box"},_vm._l((_vm.mainData),function(i,index){return _c('div',{key:'mainData' + index,staticClass:"box",on:{"click":function($event){return _vm.jump(i)}}},[_vm._v(_vm._s(i.sname))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }